import axios from 'axios';

const resolvePublicBaseUrl = () => {
  const configuredBaseUrl =
    process.env.REACT_APP_API_BASE_URL || 'https://h2tms.bte-inc.co.kr/api/bo';

  if (/\/api\/bo\/?$/.test(configuredBaseUrl)) {
    return configuredBaseUrl.replace(/\/api\/bo\/?$/, '/api/mo');
  }

  if (/\/bo\/?$/.test(configuredBaseUrl)) {
    return configuredBaseUrl.replace(/\/bo\/?$/, '/mo');
  }

  return '/api/mo';
};

const publicAxiosInstance = axios.create({
  baseURL: resolvePublicBaseUrl(),
  headers: {},
});

publicAxiosInstance.interceptors.response.use(
  ({ data }) => data,
  (error) => ({
    success: false,
    data: { error },
  }),
);

export default publicAxiosInstance;
